import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

// Components
import Form from "./Childs/Form";
import FormCard from "../../Common/Childs/Structure/FormCard";
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";

// Context
import { useWallet } from "../../../context/WalletContextProvider";
import { useGlobal } from "../../../context/GlobalContextProvider";

// Constants
const INITIAL_FORM_STATE = {
  artist_name: "",
  artist_address: "",
  artist_email: "",
  payment_address: "",
};

const ARTIST_DESCRIPTION = 
  "Welcome to Fund Raisin's Art Pack tool! Showcase your creativity and make a difference by turning your art into exclusive NFTs. With our easy-to-use platform, you can upload your Art Packs and give Sponsors permission to use your Art Packs with their campaigns.";

// API Service
const artistAPI = {
  getByWallet: async (account) => {
    const res = await fetch(`/api/artist/wallet/${account}`);
    if (res.status === 200) {
      return res.json();
    }
    return null;
  },

  update: async (account, data) => {
    return fetch(`/api/artist/wallet/${account}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    });
  },
};


const Index = () => {
  const { account } = useWallet();
  const { setSpinner } = useGlobal();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [copyData, setCopyData] = useState(INITIAL_FORM_STATE);

  // Normalize artist data for form
  const normalizeArtistData = useCallback((data) => {
    const paymentAddress = data.payment_address && account === 0 
      ? "" 
      : (data.payment_address || account);

    return {
      artist_name: data.artist_name || "",
      artist_address: data.artist_address || "",
      artist_email: data.artist_email || "",
      payment_address: paymentAddress || "",
    };
  }, [account]);

  // Load artist data from API
  const loadArtistData = useCallback(async () => {
    if (!account) return;

    setSpinner(true);
    try {
      const data = await artistAPI.getByWallet(account);
      if (data) {
        const normalizedData = normalizeArtistData(data);
        setFormData(normalizedData);
        setCopyData(normalizedData);
      }
    } catch (error) {
      console.error("Error loading artist data:", error);
    } finally {
      setSpinner(false);
    }
  }, [account, setSpinner, normalizeArtistData]);

  // Load data when account changes
  useEffect(() => {
    loadArtistData();
  }, [loadArtistData]);

  // Handle form submission
  const handleSubmit = useCallback(async (data) => {
    setSpinner(true);
    try {
      const payload = {
        artist_name: data.artist_name,
        artist_address: account,
        artist_email: data.artist_email,
        payment_address: data.payment_address,
      };

      await artistAPI.update(account, payload);
      navigate("/artist/art-pack");
    } catch (error) {
      console.error("Error updating artist data:", error);
    } finally {
      setSpinner(false);
    }
  }, [account, navigate, setSpinner]);

  return (
    <>
      <Title title="Artist General Settings" />
      <Description text={ARTIST_DESCRIPTION} />
      <FormCard>
        <Form
          handleSave={handleSubmit}
          formData={formData}
          setFormData={setFormData}
          copyData={copyData}
          account={account}
          isWalletConnected={account != null}
        />
      </FormCard>
    </>
  );
};

export default Index;
